import React from 'react';
import { InlineSpinner } from '../../components/common/spinner';
import { RedirectHeader } from '../../components/layout/redirect-header';
import { Footer } from '../../components/layout/footer';
import { TopicSelectionContent } from '../../components/topic-selection-content';
import { useTopicPreferences, MAX_SELECTIONS } from '../../hooks/api/useTopicPreferencesPage';

export const TopicPreferencesOnboarding: React.FC = () => {
  const topicPreferences = useTopicPreferences({ mode: 'onboarding' });
  const {
    topicTagGroups,
    isLoading,
    selectedTagGroupIds,
    handleToggleTagGroup,
    maxSelections,
    layout,
    handleSkip,
    handleContinue,
    isSaving,
    isUpdatingUser,
  } = topicPreferences;

  if (isLoading) {
    return (
      <div className="flex min-h-screen flex-col bg-white">
        <RedirectHeader />
        <div className="flex flex-1 items-center justify-center">
          <InlineSpinner />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <RedirectHeader />
      <div className="flex flex-1 items-center justify-center bg-white py-12">
        <div className="max-w-180 flex w-full flex-col items-center gap-12 px-4">
          <div className="flex w-full flex-col items-center gap-2">
            <h1 className="font-albert-sans text-center text-2xl font-semibold text-black">
              What are you most interested in?
            </h1>
            <p className="font-open-sans text-center text-base font-normal text-neutral-700">
              Choose up to {maxSelections} topics so we can show you the most relevant stories and resources. You can
              always change your preferences later in your profile.
            </p>
          </div>
          <div className="w-full max-w-[630px]">
            <TopicSelectionContent
              topicTagGroups={topicTagGroups}
              isLoading={false}
              selectedTagGroupIds={selectedTagGroupIds}
              onToggleTagGroup={handleToggleTagGroup}
              maxSelections={MAX_SELECTIONS}
              useShortDescription={true}
              layout={layout}
            />
          </div>
          <div className="flex w-full flex-col items-center justify-center gap-4 sm:flex-row sm:gap-6">
            <button
              type="button"
              onClick={handleSkip}
              className="bg-button-secondary flex w-full max-w-[303px] items-center justify-center rounded-full px-7 py-2.5"
              disabled={isUpdatingUser}
            >
              <span className="text-primary font-albert-sans text-base font-medium leading-5">Skip</span>
            </button>
            <button
              className="bg-button-primary w-full max-w-[303px] rounded-full px-7 py-2.5"
              onClick={handleContinue}
              disabled={selectedTagGroupIds.length === 0 || isSaving || isUpdatingUser}
            >
              <span className="font-albert-sans text-base font-medium leading-5 text-white">
                {isSaving || isUpdatingUser ? 'Saving...' : 'Done'}
              </span>
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
